<template>
	<div>
		<NavBar :admin="true" :items="items" />
		<v-main>
			<v-container>
        <v-row no-gutters>
          <v-btn small fab class="mb-3" color="primary" @click="showNewResult = !showNewResult">
            <v-icon>mdi-plus</v-icon>
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn small class="mb-3" color="primary" @click="showTypes = !showTypes">
            <v-icon small>mdi-plus</v-icon>
            Tipos
          </v-btn>
          <v-dialog v-model="showTypes" max-width="35%" scrollable>
            <v-card>
              <v-card-title class="title primary--text mb-2 secondary">
                Tipos
              </v-card-title>
              <v-card-text>
                <v-btn fab color="primary" @click="showNewType = !showNewType" small>
                  <v-icon>mdi-plus</v-icon>
                </v-btn>
                <v-form v-if="showNewType" ref="form">
                  <v-row no-gutters class="mt-2">
                    <v-col cols="12">
                      <v-text-field
                        filled
                        v-model="newType.name_pt"
                        :placeholder="$gettext('Name') + ' PT'"
                        hide-details
                        :rules="[required]"
                        class="pa-1"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12">
                      <v-text-field
                        filled
                        v-model="newType.name_en"
                        :placeholder="$gettext('Name') + ' EN'"
                        hide-details
                        :rules="[required]"
                        class="pa-1"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12">
                      <v-text-field
                        filled
                        v-model="newType.name_es"
                        :placeholder="$gettext('Name') + ' ES'"
                        hide-details
                        :rules="[required]"
                        class="pa-1"
                      ></v-text-field>
                    </v-col>
                  </v-row>
                  <v-row no-gutters>
                    <v-spacer></v-spacer>
                    <v-btn small class="my-3" color="primary" @click="addType" :loading="addTypeLoading">
                      Criar
                    </v-btn>
                  </v-row>
                </v-form>
                <p v-if="types.length == 0" class="font-weight-thin ml-2 mt-2">Sem tipos.</p>
                <v-list v-else>
                  <v-list-item
                    v-for="type in types"
                    :key="type.id"
                    style="border: 1px solid #e0e0e0; border-radius: 5px"
                  >
                    <v-list-item-content>
                      <v-list-item-title>
                        {{ type.name }}
                      </v-list-item-title>
                    </v-list-item-content>
                    <v-list-item-action>
                      <v-row no-gutters>
                        <!-- <v-btn color="primary" icon small @click="type.edit = !type.edit">
                          <v-icon color="primary" small>mdi-pencil</v-icon>
                        </v-btn> -->
                        <v-btn color="primary" icon small @click="deleteType(type)">
                          <v-icon color="primary" small>delete</v-icon>
                        </v-btn>
                      </v-row>
                    </v-list-item-action>
                  </v-list-item>
                </v-list>
              </v-card-text>
              <v-divider></v-divider>
              <v-card-actions>
                <v-btn color="primary" text @click="showTypes = false">
                  <translate>Close</translate>
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-row>
        <v-card v-if="showNewResult" class="mb-4">
          <v-card-title>
            Novo Resultado
          </v-card-title>
          <v-card-text>
            <PulseResultForm ref="form" :result="newResult" :edit="true" :points="points" :types="types" />
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions>
            <v-spacer></v-spacer>
						<v-btn color="primary darken-1" text @click="addResult" :loading="addResultLoading">
							<translate>Save</translate>
						</v-btn>
          </v-card-actions>
        </v-card>
        <v-progress-linear v-if="loading" indeterminate color="primary"></v-progress-linear>
        <template v-else>
          <p v-if="results.length == 0" class="font-weight-thin ml-2">Sem resultados.</p>
          <PulseResult
            v-else
            v-for="(result, i) in results" :key="i" :result="result" :name="i" class="mb-2" @remove-result="removeResult"
            :points="points"
            :types="types"
          />
        </template>
      </v-container>
    </v-main>
  </div>
</template>

<script>
import NavBar from "@/components/authentication/NavBar.vue";
import PulseResult from "@/components/admin/PulseResult.vue";
import PulseResultForm from "@/components/admin/PulseResultForm.vue";
import axios from "axios";

export default {
  name: "Pulse",
  components: {
    NavBar,
    PulseResult,
    PulseResultForm
  },
  data: () => ({
    loading: false,
    showNewResult: false,
    newResult: {
      note_pt: "",
      note_en: "",
      note_es: "",
      point_types: [],
      icds: [],
      points: []
    },
    addResultLoading: false,
    addTypeLoading: false,
    showTypes: false,
    showNewType: false,
    newType: {
      name_pt: "",
      name_en: "",
      name_es: ""
    },
    results: [],
    points: [],
    types: []
  }),
  computed: {
		items() {
			return [
				{
					text: this.$gettext("Dashboard"),
					disabled: false,
					link: true,
					to: "/admin/dashboard"
				},
				{
					text: "Pulso",
					disabled: true,
					link: true
				}
			];
		},
    required() {
			return (value) => !!value || this.$gettext("Required.");
		}
	},
  methods: {
    addResult() {
      this.addResultLoading = true;
      axios
        .post("/admin/pulse-results/new", this.newResult)
        .then(response => {
          console.log(response.data);
          this.results.push(response.data.result);
          this.newResult.point_types = [];
          this.newResult.icds = [];
          this.newResult.points = [];
          this.$refs.form.reset();
          this.showNewResult = false;
          this.addResultLoading = false;
        })
        .catch(error => {
          console.log(error);
          this.addResultLoading = false;
        });
    },
    removeResult(result) {
      this.results.splice(this.results.indexOf(result), 1);
    },
    addType() {
      if(this.$refs.form.validate()) {
        this.addTypeLoading = true;
        axios
          .post("/admin/pulse_types/new", this.newType)
          .then(response => {
            console.log(response.data);
            this.types.push(response.data.type);
            this.newType.name_pt = "";
            this.newType.name_en = "";
            this.newType.name_es = "";
            this.addTypeLoading = false;
            this.showNewType = false;
          })
          .catch(error => {
            console.log(error);
            this.addTypeLoading = false;
          });
      }
    },
    deleteType(type) {
      axios
        .post("/admin/pulse_types/" + type.id + "/delete")
        .then(response => {
          console.log(response.data);
          this.types.splice(this.types.indexOf(type), 1);
        })
        .catch(error => {
          console.log(error);
        });
    }
  },
  created() {
    this.loading = true;
    axios
			.get("/admin/pulse-results")
			.then(response => {
        console.log(response.data);
				if (response.status === 200) {
          this.results = response.data.results;
          this.points = response.data.points;
          this.types = response.data.types;
					this.loading = false;
				}
			})
			.catch(error => console.log(error));
  }
}
</script>